'use strict';

import { fetchJson } from '../utils/fetchJson';

/**
 * GameRepository
 */
class GameRepository {
  /**
   * Constructor of GameRepository.
   * @param {Object} options
   * @return {*}
   */
  constructor(options) {
    this._options = options;
  }

  async getGameData() {
    return new Promise((resolve, reject) => {
      var url = `${this._options.apiDomain}/sdk/game/${this._options.gameId}`;
      if (this._options.version) url += `?v=${this._options.version}`;
      fetchJson(url, {
        method: 'GET',
        credentials: 'include',
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }
}
export default GameRepository;
